// Figür öncüllerden ÖNCE (GRAFIK_EKSEN_STANDARDI v2.0 §14, KURALLAR §4.21.1 v1.39 —
// Mehmet kararı 2026-09-26). Gövdeyi figürün üstünde ve altında kalacak iki parçaya böler.
//
// İKİZ: backend/src/services/pdfExport.js `_figurOnculBol` — aynı kural basımda uygulanır.
// Kilit: tests/test_figur_oncul_bol.js (iki tarafı aynı örneklerle koşturur).
//
// Bölme noktası: ilk `I.` / `I)` satırı ya da madde imi (`•`, `$\bullet$`). Hemen
// üstündeki boş olmayan satır AÇIŞ ise (yalnız `\textbf{...}`, noktalama ile bitmiyor —
// §4.21.1 bölünmüş kapanışın açışı) ya da `:` ile bitiyorsa o da figürün altına iner.
// Satırın SON cümlesi listeyi tanıtıyorsa ("Hakem bu turla ilgili üç ifade
// değerlendirmektedir." — eski Biçim B, 2026-09-27) o cümle de iner.
// Güvenli düşüş (null): üst parça boş / bölme açık `{` ya da `$` içinde.

const BOLME_BASI = /^\s*(?:I\s*[.)]\s|•\s|\$\\bullet\$\s)/;
const ACIS_SATIRI = /^\s*\\textbf\{[^{}]*[^.?!:;,\s{}]\s*\}\s*(?:\\\\)?\s*$/;
const YUKARI_ATIF = /yukar[ıi]da(?:ki)?\s+(?:\S+\s+){0,3}?(?:grafi|şekil|sekil|tablo|çizil|cizil|gösteril|gosteril|verilmi|diyagram)/i;
const GIRIS_CUMLESI = /(?:^|\s)(?:iki|üç|uc|dört|dort|beş|bes|bazı|bazi|birkaç|birkac|aşağıdaki|asagidaki)\s+(?:\S+\s+)?(?:ifade|yargı|yargi|öncül|oncul|bilgi|görüş|gorus|çıkarım|cikarim|tespit|iddia)\S*\s+(?:\S+\s+){0,2}?\S+\.\s*(?:\\\\)?\s*$/i;

function denge(metin) {
  let derinlik = 0;
  let dolar = 0;
  for (let i = 0; i < metin.length; i++) {
    if (metin[i] === '\\') { i++; continue; }
    if (metin[i] === '{') derinlik++;
    else if (metin[i] === '}') derinlik--;
    else if (metin[i] === '$') dolar++;
  }
  return { derinlik, tekDolar: dolar % 2 === 1 };
}

export function figurOnculBol(govde) {
  if (typeof govde !== 'string' || !govde) return null;
  const satirlar = govde.split('\n');
  let bol = satirlar.findIndex((s) => BOLME_BASI.test(s));
  if (bol <= 0) return null;
  let j = bol - 1;
  while (j >= 0 && !satirlar[j].trim()) j--;
  if (j >= 0 && (ACIS_SATIRI.test(satirlar[j]) || /:\s*(?:\\\\)?\s*$/.test(satirlar[j]))) bol = j;
  else if (j >= 0) {
    const cumleler = satirlar[j].split(/(?<=[.!?])\s+(?=\S)/);
    if (GIRIS_CUMLESI.test(cumleler[cumleler.length - 1])) {
      if (cumleler.length === 1) bol = j;
      else {
        const son = cumleler.pop();
        satirlar.splice(j, 1, cumleler.join(' '), son);
        bol = j + 1;
      }
    }
  }
  // Figüre "yukarıda … gösterilmiş/çizilmiş" diye atıf yapan paragraf figürün ALTINDA
  // doğrudur (§14) — hemen üstteyse o da iner.
  let k = bol - 1;
  while (k >= 0 && !satirlar[k].trim()) k--;
  if (k > 0 && YUKARI_ATIF.test(satirlar[k])) bol = k;
  const ust = satirlar.slice(0, bol).join('\n');
  const alt = satirlar.slice(bol).join('\n');
  if (!ust.trim() || !alt.trim()) return null;
  const d = denge(ust);
  if (d.derinlik !== 0 || d.tekDolar) return null;
  return { ust: ust.replace(/\s+$/, ''), alt: alt.replace(/^\s+/, '') };
}
